import api from './api';

export type NivelLog = 'ERROR' | 'WARN' | 'INFO' | 'DEBUG';

export interface LinhaLog {
  ts: string | null;
  level: NivelLog;
  cat: string;
  msg: string;
  meta?: Record<string, unknown>;
}

export interface DiaLog {
  data: string;
  tamanhoBytes: number;
  atualizadoEm: string;
}

export interface AmbienteLog {
  ambiente: string;
  dias: DiaLog[];
  atualizadoEm: string | null;
}

export interface AmbientesLogResponse {
  atual: string;
  retencaoDias: number;
  tamanhoTotalBytes: number;
  ambientes: AmbienteLog[];
}

export interface LogResponse {
  ambiente: string;
  data: string;
  total: number;
  truncado: boolean;
  tamanhoBytes: number;
  linhas: LinhaLog[];
}

export interface FiltroLog {
  ambiente: string;
  data: string;
  nivel?: string;
  cat?: string;
  busca?: string;
  limite?: number;
}

export interface ConfigLog {
  retencaoDias: number;
  limiteDiarioMB: number;
  nivelMinimo: NivelLog;
  registrarHttp: boolean;
  incluirLeituras: boolean;
  requisicaoLentaMs: number;
  registrarWebhooks: boolean;
  capturarConsole: boolean;
}

export interface ConfigLogResponse {
  config: ConfigLog;
  padrao: ConfigLog;
  limites: Record<'retencaoDias' | 'limiteDiarioMB' | 'requisicaoLentaMs', { min: number; max: number }>;
  pastaLogs: string;
  ambienteAtual: string;
  gravacaoAtiva: boolean;
}

export const logSistemaService = {
  getConfig: async (): Promise<ConfigLogResponse> => {
    const { data } = await api.get('/logs-sistema/config');
    return data;
  },

  saveConfig: async (config: ConfigLog): Promise<ConfigLog> => {
    const { data } = await api.put('/logs-sistema/config', config);
    return data.config;
  },

  getAmbientes: async (): Promise<AmbientesLogResponse> => {
    const { data } = await api.get('/logs-sistema/ambientes');
    return data;
  },

  getLogs: async (filtro: FiltroLog): Promise<LogResponse> => {
    const { data } = await api.get('/logs-sistema', { params: filtro });
    return data;
  },

  baixar: async (ambiente: string, data: string): Promise<void> => {
    const res = await api.get('/logs-sistema/download', { params: { ambiente, data }, responseType: 'blob' });
    const url = window.URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${ambiente}-${data}.log`;
    a.click();
    window.URL.revokeObjectURL(url);
  }
};
